// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { PharmacyGroup } from '../_models/pharmacy-group.model';
// Models
import { QueryParamsModel } from '../../_base/crud';

export enum PharmacyGroupActionTypes {
  AllPharmacyGroupsRequested = '[PharmacyGroups] All PharmacyGroups Requested',
  AllPharmacyGroupsLoaded = '[PharmacyGroups] All PharmacyGroups Loaded',
  PharmacyGroupOnServerCreated = '[PharmacyGroups] PharmacyGroup On Server Created',
  PharmacyGroupCreated = '[PharmacyGroups] PharmacyGroup Created',
  PharmacyGroupOnServerUpdated = '[PharmacyGroups] PharmacyGroup On Server Updated',
  PharmacyGroupUpdated = '[PharmacyGroups] PharmacyGroup Updated',
  PharmacyGroupOnServerDeleted = '[PharmacyGroups] PharmacyGroup On Server Deleted',
  PharmacyGroupDeleted = '[PharmacyGroups] PharmacyGroup Deleted',
  PharmacyGroupsPageRequested = '[PharmacyGroups] PharmacyGroups Page Requested',
  PharmacyGroupsPageLoaded = '[PharmacyGroups] PharmacyGroups Page Loaded',
  PharmacyGroupsPageCancelled = '[PharmacyGroups] PharmacyGroups Page Cancelled',
  PharmacyGroupsPageToggleLoading = '[PharmacyGroups] PharmacyGroups Page Toggle Loading',
  PharmacyGroupsActionToggleLoading = '[PharmacyGroups] PharmacyGroups Action Toggle Loading',
  ThrowPharmacyGroupError = '[PharmacyGroups] Throw Error',
  FirePharmacyGroupSuccess = '[PharmacyGroups] Fire Success',
}

export class PharmacyGroupOnServerCreated implements Action {
  readonly type = PharmacyGroupActionTypes.PharmacyGroupOnServerCreated;
  constructor(public payload: { pharmacyGroup: PharmacyGroup }) {}
}

export class PharmacyGroupCreated implements Action {
  readonly type = PharmacyGroupActionTypes.PharmacyGroupCreated;
  constructor(public payload: { pharmacyGroup: PharmacyGroup }) {}
}

export class ThrowPharmacyGroupError implements Action {
  readonly type = PharmacyGroupActionTypes.ThrowPharmacyGroupError;
  constructor(public payload: { error: any }) {}
}

export class FirePharmacyGroupSuccess implements Action {
  readonly type = PharmacyGroupActionTypes.FirePharmacyGroupSuccess;
  constructor(public payload: { action_type: string }) {}
}

export class PharmacyGroupOnServerUpdated implements Action {
  readonly type = PharmacyGroupActionTypes.PharmacyGroupOnServerUpdated;
  constructor(
    public payload: {
      partialPharmacyGroup: Update<PharmacyGroup>;
      pharmacyGroup: PharmacyGroup;
    },
  ) {}
}
export class PharmacyGroupUpdated implements Action {
  readonly type = PharmacyGroupActionTypes.PharmacyGroupUpdated;
  constructor(
    public payload: {
      partialPharmacyGroup: Update<PharmacyGroup>;
      pharmacyGroup: PharmacyGroup;
    },
  ) {}
}

export class PharmacyGroupOnServerDeleted implements Action {
  readonly type = PharmacyGroupActionTypes.PharmacyGroupOnServerDeleted;
  constructor(public payload: { id: number }) {}
}

export class PharmacyGroupDeleted implements Action {
  readonly type = PharmacyGroupActionTypes.PharmacyGroupDeleted;
  constructor(public payload: { id: number }) {}
}

export class PharmacyGroupsPageRequested implements Action {
  readonly type = PharmacyGroupActionTypes.PharmacyGroupsPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class PharmacyGroupsPageLoaded implements Action {
  readonly type = PharmacyGroupActionTypes.PharmacyGroupsPageLoaded;
  constructor(
    public payload: { pharmacyGroups: PharmacyGroup[]; totalCount: number; page: QueryParamsModel },
  ) {}
}

export class PharmacyGroupsPageCancelled implements Action {
  readonly type = PharmacyGroupActionTypes.PharmacyGroupsPageCancelled;
}

export class PharmacyGroupsPageToggleLoading implements Action {
  readonly type = PharmacyGroupActionTypes.PharmacyGroupsPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class PharmacyGroupsActionToggleLoading implements Action {
  readonly type = PharmacyGroupActionTypes.PharmacyGroupsActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export type PharmacyGroupActions =
  | PharmacyGroupCreated
  | PharmacyGroupUpdated
  | PharmacyGroupDeleted
  | PharmacyGroupOnServerCreated
  | PharmacyGroupOnServerUpdated
  | PharmacyGroupOnServerDeleted
  | PharmacyGroupsPageLoaded
  | PharmacyGroupsPageCancelled
  | PharmacyGroupsPageToggleLoading
  | PharmacyGroupsPageRequested
  | ThrowPharmacyGroupError
  | FirePharmacyGroupSuccess
  | PharmacyGroupsActionToggleLoading;
